/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { MembershipLevel } from './types';

export interface CouponCode {
    code: string;
    membershipLevel: MembershipLevel;
    description: string;
}

export const VALID_COUPONS: CouponCode[] = [
    {
        code: 'PREMIUM2026',
        membershipLevel: MembershipLevel.PREMIUM,
        description: 'New Year Premium Membership'
    },
    {
        code: 'ADVANCED_PRO',
        membershipLevel: MembershipLevel.ADVANCED,
        description: 'Professional Partner Access'
    },
    {
        code: 'NEXTGEN_FOLLOWER',
        membershipLevel: MembershipLevel.NEXTGEN,
        description: 'NextGen Early Adopter'
    }
];

/**
 * Validate coupon code and return associated membership level
 */
export const validateCouponCode = (code: string): MembershipLevel | null => {
    const coupon = VALID_COUPONS.find(c => c.code === code.toUpperCase());
    return coupon ? coupon.membershipLevel : null;
};
